export default "__VITE_ASSET__B_C0$UN3__"